import React, { useEffect, useState } from "react";
import { Button, Card } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { BasicModal } from "../../../../components/Shared";
import { ListQuiz } from "../../../../components/Admin/QuizComponents/ListQuiz/ListQuiz";
import { QuizForm } from "../../../../components/Admin/QuizComponents/QuizForm/QuizForm";
import { PageHeader, BrandThemeProvider } from "../../../../ui";
import { useThemeRuntime } from "../../../../ui/theme/ThemeRuntimeProvider";
import {
  NEW_EVALUACIONES,
  NEW_TEACHER_EVAL_DASHBOARD,
} from "../../../../ui/featureFlags";
import { TeacherEvalDashboard } from "../../../../components/Admin/QuizComponents/TeacherEvalDashboard";

import paso1 from "../../../../assets/illustrations/guia-quiz/paso1.png";
import paso2 from "../../../../assets/illustrations/guia-quiz/paso2.png";
import paso3 from "../../../../assets/illustrations/guia-quiz/paso3.png";

import styles from "./Page_Teacher_Quiz.module.scss";

export function Page_Teacher_Quiz() {
  const { t } = useTranslation("teachers");
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);

  const onOpenCloseModal = () => setShowModal((prev) => !prev);
  const onReload = () => setReload((prev) => !prev);

  // Overrides del editor de estilos (guia rapida por pagina). En la sesion de un
  // diseñador ganan; para el resto, valor por defecto (i18n + asset).
  const { resolvedOverrides } = useThemeRuntime();
  const ov = (key, fallback) => {
    const v = resolvedOverrides[key];
    return typeof v === "string" && v.trim() ? v : fallback;
  };

  useEffect(() => {
    // reservado por si luego quieres analytics / side-effects
  }, []);

  const steps = [
    {
      title: ov("text.quiz.guide.step1.title", t("pages.quizStep1")),
      description: ov("text.quiz.guide.step1.desc", t("pages.quizStep1Desc")),
      illustration: ov("image.quiz.guide.step1", paso1),
    },
    {
      title: ov("text.quiz.guide.step2.title", t("pages.quizStep2")),
      description: ov("text.quiz.guide.step2.desc", t("pages.quizStep2Desc")),
      illustration: ov("image.quiz.guide.step2", paso2),
    },
    {
      title: ov("text.quiz.guide.step3.title", t("pages.quizStep3")),
      description: ov("text.quiz.guide.step3.desc", t("pages.quizStep3Desc")),
      illustration: ov("image.quiz.guide.step3", paso3),
    },
  ];
  const guideTitleOv = ov("text.quiz.guide.title", undefined);

  // Dashboard nuevo (strangler): reorganiza Evaluaciones en dashboard por
  // clases/alumnos. Con el flag off se mantiene la pagina actual intacta.
  if (NEW_TEACHER_EVAL_DASHBOARD) {
    return (
      <BrandThemeProvider>
        <div className={styles.page}>
          <TeacherEvalDashboard />
        </div>
      </BrandThemeProvider>
    );
  }

  const content = (
    <div className={styles.page}>
      <PageHeader
        title={t("pages.quizTitle")}
        description={t("pages.quizDesc")}
        steps={steps}
        guideTitle={guideTitleOv}
        extra={
          <Button
            type="primary"
            size="large"
            icon={<PlusOutlined />}
            onClick={onOpenCloseModal}
            className={NEW_EVALUACIONES ? undefined : styles.primaryAction}
          >
            {t("pages.newEvalButton")}
          </Button>
        }
      />

      <Card
        className={styles.card}
        variant="outlined"
        styles={{ body: { padding: 16 } }}
      >
        <div className={styles.tableWrap}>
          <ListQuiz reload={reload} onReload={onReload} />
        </div>
      </Card>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={t("pages.createEvalTitle")}
        size="large"
      >
        <QuizForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </div>
  );

  if (NEW_EVALUACIONES) {
    return <BrandThemeProvider>{content}</BrandThemeProvider>;
  }

  return content;
}
